import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { AppRouteComponentProps } from 'components/AppRoutes';
import { useSelector } from 'react-redux';
import { isSharedScorecardsProvided } from 'store/scorecards';
import { URL_LIST } from 'constants/urls';

const MY_TEAM_ACTIVE_TAB_STORAGE_KEY = 'v_myTeam.selectedTab';

export default function MyTeamPage({ currentRoute }: AppRouteComponentProps) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isSharedScorecardsAccessible = useSelector(isSharedScorecardsProvided);

  const routes = currentRoute.routes ?? [];

  const displayedTabs = isSharedScorecardsAccessible
    ? routes
    : routes?.filter(({ path }) => path !== 'shared-scorecards');

  useEffect(() => {
    if (pathname !== '/my-team') {
      return;
    }

    const storedTab = localStorage.getItem(MY_TEAM_ACTIVE_TAB_STORAGE_KEY);
    const storedTabExists = displayedTabs.some(
      ({ path }) => path === storedTab,
    );
    const nextTab = storedTabExists ? storedTab : displayedTabs[0]?.path;

    if (nextTab) {
      navigate(`${nextTab}/${URL_LIST}`, { replace: true });
    }
  }, [displayedTabs, navigate, pathname]);

  useEffect(() => {
    const activeTab = pathname.split('/')[2];

    if (activeTab && displayedTabs?.find((tab) => tab.path === activeTab)) {
      localStorage.setItem(MY_TEAM_ACTIVE_TAB_STORAGE_KEY, activeTab);
    }
  }, [pathname, displayedTabs]);

  return <Outlet />;
}
